export default {
  dba_ds_report: 'DS报告',
  dba_agent_token_total_done: '已完成，累计消耗 {tokens} tokens。',
  dba_agent_thinking: '{agentName} 思考与数据查询中...',
  dba_agent_thinking_ds: '生成报告预计需要5分钟，对话已保存，可随时离开',
  dba_agent_time_spent: '用时',
  dba_agent_thinkover_fastqa: '{agentName} 快速思考与数据查询完毕',
  dba_agent_thinkover_deepthink: '{agentName} 深度思考与数据查询完毕',
  dba_agent_thinkover_auto: '{agentName} 智能思考与数据查询完毕',
  dba_agent_thinkover_default: '{agentName} 思考与数据查询完毕',
  dba_agent_plan_done: '{agentName} 执行计划制定完毕',
  dba_source_tip_all: '支持情报、與情、部分经分数据查询，暂未接入PUBGM经分数据',
  dba_source_tip: '支持情报、舆情、经分数据查询',
  dba_source_tip_no_dashboard: '暂未接入PUBGM经分数据',
  dba_may_also_ask: '你可能还想问',
  dba_time_over: '数据查询超时，请稍后再试',
  dba_qa_ask: '询问任何游戏数据问题',
  dba_qa_ask_skill: '输入你的问题，或输入@引用知识库，/ 唤起Skills...',
  dba_qa_ask_knowledge: '输入你的问题，或输入@引用知识库',
  dba_qa_ask_skill_only: '输入你的问题，或输入/ 唤起Skills...',
  dba_qa_ask_question: '输入你的问题',
  dba_qa_ai_table_ask: '询问任何游戏数据问题，生成表格结果',
  dba_qa_techland_ask: '请输入任何Techland游戏数据问题，支持波兰语询问',
  dba_title_left: '您的游戏数据智能',
  dba_title_right: '专家',
  dba_change_list: '换一批',
  dba_input_send: '发送',
  dba_input_voice: '语音输入',
  dba_input_stop: '停止',
  dba_new_qa: '新建对话',
  dba_menu_today: '今日',
  dba_menu_week: '近7天',
  dba_menu_month: '近30天',
  dba_menu_early: '更早',
  dba_menu_share: '分享',
  dba_menu_share_link: '分享链接',
  dba_menu_share_caption: '仅拥有报告权限的用户可查看此分享内容',
  dba_menu_sensitive_content_mgmt: '当前会话存在管理看板敏感数据，无法分享',
  dba_menu_sensitive_content_both:
    '当前会话存在管理看板、经分敏感数据，无法分享',
  dba_menu_sensitive_content: '当前会话存在经分敏感数据，无法分享',
  dba_menu_sensitive_data_detected: '检测到敏感数据',
  dba_menu_rename: '重命名',
  dba_menu_confirm: '确认删除？',
  dba_menu_confirm_content: '会话记录将被永久删除且无法恢复',
  dba_menu_chat_archive: '收藏',
  dba_menu_chat_archive_done: '已收藏到对话列表',
  dba_menu_chat_archive_remove: '取消收藏',
  dba_menu_chat_archive_remove_done: '已取消收藏',
  dba_qa_save: '最多可保存50个对话，最长存储时间为半年',
  dba_home_hello: '嗨，我是 ',
  dba_home_brainy: 'Brainy',
  dba_regenerate: '重新生成',
  dba_data_sources: '数据来源',
  dba_data_insight: '数据洞察',
  dba_switch_agent: '切换成智能体：',
  dba_go_to_agent: '前往Agent',
  dba_switch_tool: '使用工具：',
  dba_tools_running: '{count}个{tool}工具运行中',
  dba_tools_completed: '{count}个{tool}工具',
  dba_chart_stop: '已停止生成',
  dba_input_cancel: '取消',
  dba_common_like: '点赞',
  dba_common_unlike: '点踩',
  dba_common_edit: '修改',
  dba_common_copy: '复制',
  dba_common_refresh: '重新生成',
  dba_common_copy_success: '复制成功',
  dba_common_copy_failed: '复制失败，请重试',
  dba_common_edit_failed: '修改失败',
  dba_common_feedback_tips: '感谢您的反馈！',
  dba_switch_voice_to_text_failed: '语音转文字失败',
  dba_common_refresh_failed: '重新生成失败',
  dba_ParseError: '网络请求解析失败，请检查网络连接或稍后重试。',
  dba_invalid_request: '请求无效，请刷新页面或重试。',
  dba_method_notFound: '请求的服务不存在，请检查您的操作是否正确。',
  dba_invalid_params: '参数验证失败，请检查输入内容后重试。',
  dba_internal_error: '当前访问人数过多，请稍后再来体验。',
  dba_internal_length_max: '提交内容超出字数限制，请简化后重试。',
  dba_max_turns: '触发大模型限制，Agent已收到告警，请尝试重试。',
  dba_menu_loading: '加载中…',
  dba_deep_thinking: '深度思考',
  dba_deep_on: '开启：答复更全面，稍慢',
  dba_deep_off: '关闭：答复更简洁，较快',
  dba_upload_img_title: '上传附件',
  dba_upload_img_tips:
    '最多支持 5 个文件，接受Markdown(.md)、PDF(.pdf)、Word(.docx)、PPT(.pptx)、Excel(.xlsx)、Html(.html)、图片（.jpg/.png）的文件格式。每个图片最多 5 MB，每个Markdown文件最多 1 MB，其他文件最多 10 MB',
  dba_upload_img_tips_darg: `最多支持 5 个文件，接受Markdown(.md)、PDF(.pdf)、Word(.docx)、PPT(.pptx)、Excel(.xlsx)、Html(.html)、图片（.jpg/.png）的文件格式。<br/>每个图片最多 5 MB，每个Markdown文件最多 1 MB，其他文件最多 10 MB`,
  dba_upload_img_error_tips:
    '最多5个文件，支持Markdown、PDF、Word、PPT、Excel、Html、PNG、JPG。<br/>图片≤5 MB，Markdown≤1 MB，其他≤10 MB。',
  dba_upload_img_disabled_tips: '{agentName} Agent暂不支持上传图片和文件',
  dba_upload_img_disabled_send_tips: '请先删除异常文件再发送',
  dba_upload_error: '上传失败',
  dba_uploading: '上传中...',
  dba_reupload: '点击重试',
  dba_upload_drag_title: '文件拖动到此处即可上传',
  dba_access_nodash:
    '以下数据洞察均来自三方情报数据，可能存在误差，请您酌情参考。',
  dba_access_dash2_left: '经查询您未拥有',
  dba_access_dash2_right:
    '经分权限；以下数据洞察均来自三方情报数据，可能存在误差，请您酌情参考。',
  dba_access_dash3_left: '经查询您拥有',
  dba_access_dash3_mid: '的经分权限，未拥有',
  dba_access_dash3_right: '经分权限；以下数据洞察包含',
  dba_access_dash3_end: '经分真实数据，请您谨慎分享。',
  dba_access_title: '敏感数据提示',
  dba_user_cost_exceeded_tip:
    '本次任务已完成，DataBrain高级模型用量已达上限，继续提问系统将自动切换至基础模型服务，请知悉。',
  // 管理看板相关文案
  dba_access_mgmt_intelligence:
    '经查询您拥有管理看板权限: 以下数据洞察包含管理看板真实数据，请您谨慎分享。',
  dba_access_mgmt_dashboard: '管理看板',
  dba_access_mgmt_dashboard_and: '和',
  dba_access_mgmt_permission_and: '权限和',
  dba_access_mgmt_permission_comma: '权限、',
  dba_access_mgmt_intelligence_prefix: '经查询您拥有',
  dba_access_mgmt_intelligence_suffix: '权限: 以下数据洞察包含',
  dba_access_mgmt_intelligence_end: '真实数据，请您谨慎分享。',
  dba_access_table: '数据来源说明',
  dba_access_table_hover: '数据来源自',
  dba_access_table_Intelligence: '情报，三方数据源',
  dba_access_table_Intelligence_new:
    '情报，基于第三方数据源的DataBrain预估数据',
  dba_access_table_Opinions: '舆情，爬虫数据',
  dba_access_table_Dashboard: '经分，游戏真实数据',
  dba_voice_listen: '正在听取...',
  dba_voice_reco: '正在识别...',
  dba_voice_fail: '没听明白，请再说一遍',
  dba_invalid_agent: '连接AI服务时遇到中断问题，请刷新页面或重试。',
  dba_invalid_image: '图片无法识别，请更换重试。',
  dba_over_token:
    '抱歉，答案超出限制，Agent已告警在优化中，如紧急请您简化问题咨询。',
  dba_rate_limit: '当前访问人数过多，请稍后再来体验。',
  dba_chat_share_user: '来自xxx的对话副本',
  dba_chat_systeem_error: '系统错误',
  dba_chat_new_menu: '新对话',
  dba_chat_feedback_title: '您觉得什么让您不满意?',
  dba_chat_feedback_placeholder:
    '我们想知道你对此回答不满意的原因，你认为更好的回答是什么？',
  dba_common_share_failed: '分享失败',
  dba_request_limit: '网络异常，请稍后再试。',
  dba_execution_timeout: 'Agent 执行已超过 30 分钟时限，请缩小问题范围后重试。',
  dba_invalid_input: '输入内容无效，请检查后重试。',
  dba_download: '下载',
  dba_downloading: '下载中...',
  dba_download_success: '下载成功',
  common_down_loading_text: '下载中',
  common_down_loading_text_loading: '下载中...',
  common_down_success_text: '下载成功',
  common_down_error_text: '下载失败',
  dba_copilot_recommend: '推荐问题',
  /** Copilot 侧栏首页推荐区标题（轻量化文案，仅 Copilot 使用） */
  dba_copilot_sidebar_recommend_title: '推荐问题',
  dba_search_chats: '搜索会话',
  dba_archive_title: '收藏夹',
  dba_file_library_title: '文件库',
  dba_file_library_tab_all: '全部',
  dba_file_library_tab_brainy: 'Brainy 生成',
  dba_file_library_tab_user: '我上传的',
  dba_file_library_search_placeholder: '搜索文件名、来源',
  dba_file_library_col_name: '文件名',
  dba_file_library_col_source: '来源',
  dba_file_library_col_created: '创建时间',
  dba_file_library_col_size: '大小',
  dba_file_library_col_type: '类型',
  dba_file_library_col_actions: '操作',
  dba_file_library_open_chat: '原始聊天',
  dba_file_library_download: '下载',
  dba_file_library_filter: '筛选',
  dba_file_library_filter_title: '筛选条件',
  dba_file_library_filter_clear: '清空',
  dba_file_library_filter_file_type: '文件类型',
  dba_file_library_filter_time: '时间范围',
  dba_file_library_filter_source: '来源',
  dba_file_library_filter_all: '全部',
  dba_file_library_time_today: '今天',
  dba_file_library_time_7d: '近 7 天',
  dba_file_library_time_30d: '近 30 天',
  dba_file_library_source_search: '搜索',
  dba_file_library_source_agent: 'Agent',
  dba_file_library_source_skill: 'Skill',
  dba_file_library_source_placeholder: '请选择来源',
  dba_file_library_please_select: '请选择',
  dba_file_library_empty: '暂无文件',
  dba_file_library_loading: '加载中...',
  dba_file_library_prev: '上一页',
  dba_file_library_next: '下一页',
  dba_file_library_type_pdf: 'PDF',
  dba_file_library_type_ppt: 'PPT',
  dba_file_library_type_word: 'Word',
  dba_file_library_type_excel: 'Excel',
  dba_file_library_type_csv: 'CSV',
  dba_file_library_type_html: 'HTML',
  dba_file_library_type_md: 'Markdown',
  dba_file_library_type_txt: 'TXT',
  dba_file_library_type_zip: 'ZIP',
  dba_file_library_type_image: 'Image',
  dba_common_flat_bar_chart: '分组柱状图',
  dba_later_viewing_text: '对话已保存，可随时离开',
  dba_no_search_result: '未找到任何结果',
  dba_new_agent: '跳转Agent',
  dba_common_custom_q: '确认执行计划，请生成分析报告',
  dba_magic_poster_confirm_generate: '确认生成数据魔法海报',
  dba_magic_poster_regenerate: '重新生成数据魔法海报',
  dba_magic_poster_high_quality: '每日3次高质量生成，之后为标准模式',
  dba_chat_type_ai_agent: '智能问答',
  dba_chat_type_magic_poster: '数据魔法海报',
  dba_magic_poster_placeholder: '询问任何数据问题',
  dba_magic_poster_inspiration_title: '海报灵感',
  dba_magic_poster_make_same: '做同款',
  dba_magic_poster_preview: '查看详情',
  dba_magic_poster_preview_close: '关闭',
  dba_magic_poster_custom_style: '自定义风格',
  dba_magic_poster_default_style: '核心指标概览',
  dba_magic_poster_quota_remaining: '今日剩余 {count} 次',
  dba_magic_poster_quota_exhausted: '今日生成次数已用完，请明天再来',
  dba_magic_poster_generating: '海报生成中...',
  dba_magic_poster_generate_btn: '生成魔法海报',
  dba_magic_poster_export_png: '导出PNG',
  dba_magic_poster_share: '分享',
  dba_magic_poster_switch_style: '切换风格',
  dba_magic_poster_custom_input_placeholder: '请输入自定义风格描述',
  dba_chat_type_ai_table: 'AI表格',
  dba_chat_type_ds_agent: 'Data Science报告',
  dba_ds_agent_section_title: '专家Agent',
  dba_no_permission: '无权限',
  dba_no_permission_desc: '请到敏感权限系统申请经分权限：',
  dba_ds_qa_ask: '请输入需要分析的时间区间、区域、渠道等参数',
  dba_ds_model_sample_empty_choice: '请选择一个报告模板后重试',
  dba_ds_report_export: '导出',
  dba_ds_report_export_error: '导出错误',
  dba_ds_report_export_content: '导出文件中包含游戏经分真实数据，请您谨慎分享',
  dba_ds_report_reset: '重置内容',
  dba_ds_report_reset_content:
    '此操作将把文件恢复至最初版本，操作不可逆，请确认是否继续？',
  dba_ds_report_reset_success: '已重置为最初版本',
  dba_confirm: '确认',
  dba_cancel: '取消',
  dba_close: '关闭',
  dba_loading: '加载中...',
  /** AI Gallery HTML 右侧预览面板 */
  dba_ai_gallery_panel_title: 'AI Gallery 预览',
  /** 预览 Tab：无内容时的占位文案 */
  dba_ai_gallery_preview_placeholder: '暂无预览内容',
  /** 预览加载失败 */
  dba_ai_gallery_preview_error: '预览加载失败',
  /** HTML 产物卡片副文案（与「HTML · …」同一行） */
  dba_ai_gallery_document_hint: '点击预览或查看代码',
  /** ZIP 文件卡片副文案 */
  dba_zip_file_download_hint: '点击下载文件',
  /** Copilot 模式下文档类卡片禁止点击 hover 提示 */
  dba_document_copilot_disabled: '暂不支持 Copilot 模式预览',
  /** 工具栏文案：图标右侧「复制」 */
  dba_ai_gallery_toolbar_copy_label: '复制',
  /** 工具栏文案：图标右侧「导出」 */
  dba_ai_gallery_toolbar_export_label: '导出',
  /** 导出按钮气泡：导出 HTML 文件 */
  dba_ai_gallery_export_html_tooltip: '导出HTML文件',
  /** 工具栏文案：图标右侧「全屏」 */
  dba_ai_gallery_toolbar_fullscreen_label: '全屏',
  /** 全屏按钮气泡：新页面打开 HTML 报告 */
  dba_ai_gallery_fullscreen_tooltip: '新页面打开',
  /** 发布主按钮 */
  dba_ai_gallery_publish: '发布',
  dba_kb_mention_trigger: '知识库',
  dba_kb_mention_empty: '暂无匹配的知识库',
  dba_kb_doc_count_unit: '篇文档',
  dba_kb_time_recent_week: '最近一周',
  dba_kb_select_title: '选择知识库',
  dba_kb_first_level_title: '知识库',
  dba_kb_second_level_title: '文档',
  dba_kb_search_placeholder: '搜索文件或知识库',
  dba_kb_doc_empty: '暂无文档',
  dba_kb_citation_title: '知识库引用',
  dba_kb_citation_expand: '更多文件请展开',
  dba_kb_citation_view_source: '跳转查看原文',
  dba_kb_citation_collapse: '收起',
  dba_kb_citation_expand_fragment: '展开引用片段',
  dba_kb_citation_docs_unit: '篇',
  /** 输入态折叠引用：@库名 N篇 */
  dba_kb_inline_doc_unit: '篇',
  dba_kb_citation_chunk_count: '片段 {count}',
  dba_kb_citation_subtitle: '基于{names} · 源文件检索回答',
  dba_kb_add_modal_caption: '加入知识库',
  dba_kb_add_tab_existing: '加入现有知识库',
  dba_kb_add_tab_new: '新建知识库',
  dba_kb_add_space_personal: '个人空间',
  dba_kb_add_space_team: '团队空间',
  dba_kb_add_select_kb: '请选择知识库',
  dba_kb_add_title: '标题',
  dba_kb_add_title_placeholder: '请输入标题',
  dba_kb_add_content: '正文',
  dba_kb_add_content_placeholder: '请输入正文',
  dba_kb_add_kb_name: '知识库名称',
  dba_kb_add_kb_desc: '知识库描述',
  dba_kb_add_confirm: '确认',
  dba_kb_add_confirm_go: '确认并前往查看',
  dba_kb_add_selection_btn: '加入知识库',
  dba_kb_add_failed: '加入知识库失败，请稍后重试',
  dba_kb_add_success: '成功保存到{kbName}',
  dba_kb_add_space: '选择空间',
  dba_kb_add_space_team_disabled_tooltip: '暂无团队空间，',
  dba_kb_add_space_team_disabled_link: '点击前往知识库创建',
  dba_kb_add_select_team: '选择团队',
  dba_kb_add_target_kb: '目标知识库',
  dba_kb_add_ai_toggle: '知识AI智能整理',
  dba_kb_add_title_required: '标题不能为空',
  dba_kb_add_content_required: '正文不能为空',
  dba_kb_add_kb_required: '请选择目标知识库',
  dba_kb_add_kb_name_required: '知识库名称不能为空',
  dba_kb_add_team_required: '请选择团队',
  dba_kb_add_kb_name_placeholder: '请输入知识库名称',
  dba_kb_add_kb_desc_placeholder: '请输入知识库描述（选填）',
  /** 发布弹窗标题「发布为网页」 */
  dba_ai_gallery_publish_modal_caption: '发布为网页',
  // 表单字段标签
  dba_ai_gallery_publish_name_cn: '网页中文标题',
  dba_ai_gallery_publish_name_cn_placeholder: '请输入网页中文标题',
  dba_ai_gallery_publish_name_en: '网页英文标题',
  dba_ai_gallery_publish_name_en_placeholder:
    'e.g. Honor of Kings Season Review',
  dba_ai_gallery_publish_desc_cn: '中文描述',
  dba_ai_gallery_publish_desc_cn_placeholder:
    '简要介绍你的作品内容、亮点与适用场景...',
  dba_ai_gallery_publish_desc_en: '英文描述',
  dba_ai_gallery_publish_desc_en_placeholder:
    'Briefly describe your work, highlights and use cases...',
  dba_ai_gallery_publish_tags: '标签',
  dba_ai_gallery_publish_tags_placeholder: '可多选，最多5个',
  dba_ai_gallery_publish_tags_max_tip: '最多选择5个标签',
  dba_ai_gallery_publish_tags_required: '请至少选择一个标签',
  dba_ai_gallery_publish_tag_create_success: '标签创建成功',
  dba_ai_gallery_publish_tag_add: '新增标签',
  dba_ai_gallery_publish_tag_name_label: '标签名称',
  dba_ai_gallery_publish_tag_name_cn_label: '中文标签',
  dba_ai_gallery_publish_tag_name_en_label: '英文标签',
  dba_ai_gallery_publish_tag_new_placeholder: '输入标签名称',
  dba_ai_gallery_publish_tag_cn_placeholder: '输入中文标签名称',
  dba_ai_gallery_publish_tag_en_placeholder: '输入英文标签名称',
  dba_ai_gallery_publish_tag_max_length_tip: '标签名不超过10字',
  dba_ai_gallery_publish_tag_cn_max_length_tip: '中文标签最多10个字符',
  dba_ai_gallery_publish_tag_en_max_length_tip: '英文标签最多20个字符',
  dba_ai_gallery_publish_tag_back: '返回',
  // 新 API visibility 字段
  dba_ai_gallery_publish_visibility: '访问权限',
  dba_ai_gallery_publish_visibility_trigger_self: '仅自己 · 只有你可以访问',
  dba_ai_gallery_publish_visibility_trigger_user: '指定人员 · 指定可访问的人员',
  dba_ai_gallery_publish_visibility_trigger_public:
    'DataBrain 全体可见 · 全员可在陈列馆查看',
  dba_ai_gallery_publish_visibility_self_title: '仅自己',
  dba_ai_gallery_publish_visibility_self_desc: '只有你可以访问',
  dba_ai_gallery_publish_visibility_user_title: '指定人员',
  dba_ai_gallery_publish_visibility_user_desc: '指定可访问的人员',
  dba_ai_gallery_publish_visibility_public_title: 'DataBrain 全体可见',
  dba_ai_gallery_publish_visibility_public_badge: '同步发布至陈列馆',
  dba_ai_gallery_publish_visibility_public_desc: '全员可在陈列馆查看',
  dba_ai_gallery_publish_data_mode: '数据类型',
  dba_ai_gallery_publish_data_mode_required: '请选择数据类型',
  dba_ai_gallery_publish_data_mode_demo: 'Demo 数据',
  dba_ai_gallery_publish_data_mode_demo_desc: '使用示例数据，适合快速预览效果',
  dba_ai_gallery_publish_data_mode_real: '真实数据',
  dba_ai_gallery_publish_data_mode_real_desc:
    '使用游戏真实数据，仅拥有数据权限者可见',
  dba_ai_gallery_publish_user_search_placeholder: '搜索用户名添加',
  dba_ai_gallery_publish_share_users_hint:
    '输入用户英文名或邮箱进行搜索，例如：zhangxiaoming',
  dba_ai_gallery_publish_share_users_required: '指定人员下请至少添加一个用户',
  dba_ai_gallery_publish_email_placeholder: '输入邮箱，回车或逗号分隔添加',
  dba_ai_gallery_publish_email_invalid: '请输入有效的邮箱地址',
  dba_ai_gallery_publish_designated_emails_required:
    '「指定人员」下请至少添加一个邮箱',
  dba_ai_gallery_publish_designated_hint:
    '输入邮箱后按回车或逗号确认；支持多人。',
  dba_ai_gallery_publish_error_required: '不能为空',
  dba_ai_gallery_publish_name_cn_required: '网页中文标题不能为空',
  dba_ai_gallery_publish_name_en_required: '网页英文标题不能为空',
  dba_ai_gallery_publish_name_cn_max_length_tip: '网页中文标题不超过40字',
  dba_ai_gallery_publish_name_en_max_length_tip: '网页英文标题不超过60字',
  dba_ai_gallery_publish_desc_cn_max_length_tip: '中文描述不超过200字',
  dba_ai_gallery_publish_desc_en_max_length_tip: '英文描述不超过300字',
  dba_ai_gallery_publish_confirm: '发布',
  dba_ai_gallery_publish_submitting: '发布中...',
  dba_ai_gallery_publish_sensitive_tip:
    '当前内容包含经分敏感数据，发布后将生成可访问的网页链接。请确认是否继续发布。',
  dba_ai_gallery_publish_still_publish: '仍要发布',
  dba_ai_gallery_publish_failed: '发布失败，请重试',
  dba_ai_gallery_publish_success: '发布成功',
  dba_ai_gallery_toolbar_copy: '复制',
  dba_ai_gallery_download_no_url: '暂无可下载地址，请确认已返回预览链接',
  dba_ai_gallery_copy_empty: '暂无 HTML 源码或预览链接可复制',
  dba_ai_gallery_copy_success: '复制成功',
  dba_ai_gallery_copy_failed: '复制失败，请重试',
  dba_ds_model_btn_prephrase: 'Data Science专业报告生成',
  dba_back_to_copilot: '用Copilot对话',
  dba_copilot_mode_tip: '当前模式下不可跳转Copilot，请切换智能问答模式',
  dba_img_loading: '图片加载中...',
  dba_chart_draggable: '可拖拽',
  dba_chart_delete: '删除',
  dba_chart_delete_title: '删除图表',
  dba_chart_delete_message: '删除后可以通过重置还原图表',
  dba_chart_delete_cancel: '取消',
  dba_copilot_historical_conversations: '历史会话',
  dba_copilot_historical_conversations_no_data: '暂无历史会话',
  dba_copilot_chat_history: '历史对话',
  dba_copilot_window_mode: '默认窗口',
  dba_copilot_floating_window: '悬浮窗口',
  dba_copilot_pin_tooltip_floating: '悬浮',
  dba_copilot_pin_tooltip_docked: '固定',
  dba_copilot_docked_window: '固定窗口',
  dba_copilot_docked_label: '固定',
  dba_copilot_docked_window_desc:
    'Copilot 固定在右侧，主内容自动收缩，适合长时间会话。',
  dba_copilot_floating_window_desc: '关闭后，Copilot 将以悬浮窗口打开',
  dba_copilot_floating_hover_desc: '打开后，Copilot 将默认固定在页面',
  dba_copilot_docked_hover_desc: '关闭后，Copilot将默认悬浮在页面',
  dba_use_template: '使用模板',
  dba_download_settings: '下载设置',
  dba_data_loading: '数据加载中...',
  dba_table_copy: '复制表格',
  dba_table_copy_success: '复制完成',
  dba_table_download: '下载完整表格',
  dba_code_copy: '复制',
  dba_code_download: '下载',
  dba_code_collapse: '收起',
  dba_code_expand: '展开',
  dba_code_collapsed_lines: '已折叠 {lines} 行代码',
  dba_use_case_title: '使用场景',
  dba_use_case_view_chat: '查看对话',

  // AgentCollection 页面
  dba_collection_title: 'Agent集',
  dba_collection_search_placeholder: '搜索 Agent',
  dba_collection_empty: '未找到任何结果',

  // AgentCard 组件
  dba_collection_card_in_use: '当前使用',
  dba_collection_card_no_access: '暂无权限',
  dba_collection_card_try_now: '立即体验',
  dba_collection_card_no_permission_text: '暂无权限，请联系Miamgao',

  // AgentSelector 组件
  dba_collection_selector_recommended: '推荐',
  dba_collection_selector_default_name: 'DataBrain Agent',
  dba_collection_selector_header_title: '选择Agent',
  dba_collection_selector_header_thinking: '思考模式',
  dba_collection_selector_header_more: '更多',
  dba_full_screen: '全屏',

  // SkillsCollection 页面
  dba_skills_collection_title: 'Skills集',
  // Skill 详情页面包屑（返回按钮）
  dba_skill_detail_back_title: 'Skill详情',
  dba_skills_collection_search_placeholder: '搜索Skill',
  dba_skills_collection_empty: '未找到匹配的 Skill',
  dba_skills_upload_btn: '上传 Skill',

  // 分类TAB
  dba_skills_category_all: '全部',
  dba_skills_category_data_analysis: '数据分析',
  dba_skills_category_opinion_analysis: '舆情分析',
  dba_skills_category_other: '其它',

  // SkillCard 组件
  dba_skills_card_source_official: '官方',
  dba_skills_card_source_personal: '个人',
  dba_skills_card_installed: '已安装',
  dba_skills_card_not_installed: '未安装',
  dba_skills_card_install: '安装到 DataBrain',
  dba_skills_card_install_tooltip: '安装',
  dba_skills_card_download: '下载到本地',
  dba_skills_card_use: '使用',
  dba_skills_card_chat_tooltip: '立即对话',
  dba_skills_card_token_tooltip: '获取Token',
  dba_skills_card_detail_tooltip: '查看详情',
  dba_skills_mention_detail_tooltip: '查看详情',
  dba_skills_mention_detail_link: '详情',

  // Skill 详情页
  dba_skill_detail_tab_usage: '使用说明',
  dba_skill_detail_tab_linkage: '联动案例',
  dba_skill_detail_tab_version: '版本历史',
  dba_skill_detail_usage_count: '使用量 : ',
  dba_skill_detail_updated_at: '更新 : ',
  dba_skill_detail_chat_now: '立即对话',
  dba_skill_detail_overview_title: '功能概述',
  dba_skill_detail_token_title: 'Token 获取',
  dba_skill_detail_token_tip_prefix:
    '首次使用如需配置 Token，可在 DataBrain 用户中心 →',
  dba_skill_detail_token_link: '个人令牌中心',
  dba_skill_detail_token_tip_suffix: '中创建并获取 Token',
  dba_skill_detail_recommend_title: '用过这个 Skills 的人也在用',
  dba_skill_detail_linkage_try: '在 Brainy 试一下',
  dba_skill_detail_linkage_key_conclusions: '关键结论',
  dba_skill_detail_linkage_empty: '暂无数据',
  dba_skill_detail_version_empty: '当前已是最新版本，暂无版本更新。',
  dba_skill_detail_version_current: '当前版本',
  dba_skill_detail_version_col_version: '版本号',
  dba_skill_detail_version_col_info: '版本更新信息',
  dba_skill_detail_version_total: '共 {count} 条',
  dba_skill_detail_version_col_time: '更新时间',
  // PosterStyleSelector 组件
  dba_poster_style_label: '风格:',
  dba_poster_style_custom: '自定义',
  dba_poster_style_not_selected: '未选择',
  dba_poster_style_custom_placeholder: '描述你希望生成的视觉风格',
  // 魔法海报风格引用文案（Question 组件显示）
  dba_poster_style_ref: '以「{styleName}」风格生成魔法海报',

  // PosterPreviewPanel 组件
  dba_poster_preview_loading: 'loading...',
  dba_poster_preview_not_generated: '未生成海报',
  dba_poster_preview_load_error: '内容加载失败，',
  dba_poster_preview_retry: '点击重试',

  // ReportStepTabs 组件
  dba_report_step_disabled_tip: '请生成分析报告',
  // 智能表格操作
  dba_smart_table_fill_column:
    '在表格中新增一列数据，列名称【{columnName}】，并说明该列的计算方式或数据来源——基于已有列计算、固定值或外部补充【{prompt}】',
  dba_smart_table_fill_row:
    '在表格中新增一行数据，并说明该行的对应条件——如日期、地区或其他维度值【{prompt}】',
  dba_smart_table_modify_column_condition: '{prompt}',
  dba_smart_table_adjust_column_format: '{prompt}',

  // 智能表格——AIColumnPopover
  dba_smart_table_ai_column_modify_condition_template:
    '修改{sheetName}表格中{colLetter}列数据的筛选或计算条件，并说明需要调整的具体条件——如时间范围、地区范围、游戏类型等【填写】',
  dba_smart_table_ai_column_adjust_format_template:
    '调整{sheetName}表格中{colLetter}列数据的展示格式，并说明目标格式——如数值单位、百分比、小数位数、日期格式等【填写】',
  dba_smart_table_table: '表格',

  // 智能表格——AIPolishPopover
  dba_smart_table_add_column: '增加列',
  dba_smart_table_add_row: '增加行',
  dba_smart_table_modify_data_condition: '修改数据条件',
  dba_smart_table_adjust_data_format: '调整数据格式',
  dba_smart_table_add_column_template:
    '在表格中新增一列数据，列名称【填写】，并说明该列的计算方式或数据来源——基于已有列计算、固定值或外部补充【填写】',
  dba_smart_table_add_row_template:
    '在表格中新增一行数据，并说明该行的对应条件——如日期、地区或其他维度值【填写】',
  dba_smart_table_modify_condition_template:
    '修改表格中的数据筛选或计算条件，并说明需要调整的具体条件——如时间范围、地区范围、游戏类型等【填写】',
  dba_smart_table_adjust_format_template:
    '调整表格中的数据展示格式，【填写，如A列】，并说明目标格式——如数值单位、百分比、小数位数、日期格式等【填写】',
  dba_smart_table_ai_help_title: '可以帮你，示例:',
  dba_smart_table_input_placeholder: '告诉 AI 你想要做什么',

  // 智能表格 - AddRowColButton
  dba_smart_table_add_blank: '新增空白',
  dba_smart_table_smart_fill: '智能填充',
  dba_smart_table_row: '行',
  dba_smart_table_column: '列',
  dba_smart_table_add_on_bottom: '在底部新增',
  dba_smart_table_add_on_right: '在右侧新增',

  // 智能表格 - ExcelSheetTabs
  dba_smart_table_create_copy: '创建副本',
  dba_smart_table_rename: '重命名',
  dba_smart_table_delete: '删除',
  dba_smart_table_create_copy_success: '创建副本成功',
  dba_smart_table_name_exists: '名称已存在，已自动重命名为 "{name}"',
  dba_smart_table_new_blank_sheet: '新建空白工作表',
  dba_smart_table_confirm_delete_sheet: '确定要删除该工作表吗？',
  dba_smart_table_delete_sheet_title: '删除工作表',

  // 智能表格 - SmartTableToolbar
  dba_smart_table_ai_polish: 'AI润色当前表格',
  dba_smart_table_undo: '撤销',
  dba_smart_table_redo: '重做',

  // 智能表格 - TableActionsBar / constants
  dba_smart_table_reset: '重置',
  dba_smart_table_copy: '复制',
  dba_smart_table_export: '导出',
  dba_smart_table_export_sensitive_disabled:
    '包含敏感数据默认不开放下载，如需下载请联系 ivyyfchen',
  dba_smart_table_save: '保存',
  dba_smart_table_fullscreen: '全屏',
  dba_smart_table_exit_fullscreen: '退出全屏',
  dba_smart_table_save_empty: '表格数据为空，无法保存',
  dba_smart_table_save_success: '保存成功',
  dba_smart_table_save_failed: '保存失败',
  dba_smart_table_copy_success: '复制成功',

  // 智能表格 - TableContextMenu
  dba_smart_table_ai_help: '可以帮你',
  dba_smart_table_modify_column_condition_label: '修改本列数据条件',
  dba_smart_table_adjust_format_label: '调整数据格式',
  dba_smart_table_sort_asc: '升序',
  dba_smart_table_sort_desc: '倒序',
  dba_smart_table_paste: '粘贴',
  dba_smart_table_insert_left: '在左侧插入',
  dba_smart_table_insert_right: '在右侧插入',
  dba_smart_table_clear_content: '清除内容',
  dba_smart_table_delete_column: '删除所在列',
  dba_smart_table_insert_above: '在上方插入',
  dba_smart_table_insert_below: '在下方插入',
  dba_smart_table_delete_row: '删除所在行',

  // 智能表格 - SmartFillForm
  dba_smart_table_column_name: '列名称',
  dba_smart_table_column_name_placeholder: '填写',
  dba_smart_table_column_name_required: '列名称不能为空',
  dba_smart_table_prompt_required: 'Prompt不能为空',
  dba_smart_table_column_prompt_placeholder:
    '该列的计算方式或数据来源——基于已有列计算、固定值或外部补充',
  dba_smart_table_row_prompt_placeholder:
    '该行的对应条件——如日期、地区或其他维度值',

  // 智能表格 - 其他
  dba_smart_table_placeholder: '智能表格',
  dba_smart_table_editable_text: '填写',
  dba_smart_table_sheet_name_empty: '工作表名称不能为空',
  dba_smart_table_sheet_name_quote_error:
    '名称的第一个或最后一个字符不能是单引号',
  dba_smart_table_sheet_name_length_error: '工作表名称不能超过30个字符',
  dba_smart_table_sheet_name_char_error: '名称中不能包含以下字符: \\ / ? * [ ]',
  dba_smart_table_blank_sheet: '空白工作表',
  dba_smart_table_reset_title: '重置内容',
  dba_smart_table_reset_message:
    '此操作将把文件恢复至最初版本，操作不可逆，请确认是否继续？',
  dba_smart_table_reset_success: '已重置为最初版本',
  dba_smart_table_confirm_delete_message: '确定要删除吗？',
  dba_smart_table_delete_success: '删除成功',

  // 智能表格 - 导出
  dba_smart_table_export_success: '导出成功',
  dba_smart_table_export_failed: '导出失败',
  dba_smart_table_export_no_data: '暂无数据可导出',
  dba_smart_table_current_sheet: '当前页',
  dba_smart_table_export_excel: 'Excel',
  dba_smart_table_export_csv: 'CSV(当前页)',
  dba_magic_poster_style_generated: '风格生成魔法海报，',
  dba_magic_poster_data_placeholder:
    '描述海报所需的数据内容，可指定数据指标、时间范围或重点结论',

  dba_new_chart_select_title: '输入#或点击，选择页面或图表',
  dba_new_chart_select_title_tips: '当前仅支持选择经分特性报表（Datalab 报表）',

  dba_new_chart_game_label: '游戏',
  dba_new_chart_game_placeholder: '选择游戏',
  dba_new_chart_second_level_title: '页面',
  dba_new_chart_chart_title: '图表',
  dba_new_chart_game_group_recent: '最近浏览',
  dba_new_chart_game_group_others: '其他',
  dba_chart_ref_tooltip_title: '引用数据',
  dba_copilot_input_chart_hover_tip: '点击选择页面或图表',
  dba_copilot_input_thinking_hover_tip: '点击选择思考模式',
  dba_gallery_default_text:
    '查询Arrows Puzzle Escape过去一个月的DAU趋势，生成一份简洁美观的HTML报告',

  // 记忆功能相关文案
  dba_memory_management: '记忆管理',
  dba_memory_title: '记忆管理',
  dba_enable_memory: '启用记忆',
  dba_memory_enabled_desc:
    'Brainy 将在后续分析中自动使用已保存的分析偏好、报告格式和近期关注事项，为你提供更连续、个性化的分析体验',
  dba_memory_disabled_desc:
    '已有记忆会保留，仅供查看，不会用于生成回答，也不会新增或更新。重新开启后可继续使用。',
  dba_memory_summary: '记忆摘要',
  dba_no_memory: '暂无记忆',
  dba_ds_template_select_title: '请选择分析模板',

  // MorePlatformBtn
  dba_platform_more_btn: '更多平台使用',
  dba_platform_pre_in: '在',
  dba_platform_workbuddy_desc1:
    'WorkBuddy 中，点击左上角的「专家·技能·连接器」，搜索',
  dba_platform_workbuddy_desc2:
    '「DataBrain」，即可使用 DataBrain 数据专家 2.0 等多个专家',
  dba_platform_wecom_desc: '企业微信中使用 DataBrain Agent 2.0，',
  dba_platform_open: '打开',
  dba_platform_wecom_name: '企业微信',
  dba_platform_chat: '对话',
  dba_platform_knot_desc1: 'Knot 的 Skills 市场中搜索「',
  dba_platform_knot_desc2: '」，即可使用官方提供的多个 Skills',
  // Opinion Report Card
  dba_opinion_report_card_link: '跳转生成报告任务',
};
